var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendsIconHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 64,
    viewBox: "0 0 97 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.059082,
    y: 0.0639648,
    width: 96.5624,
    height: 63.6551,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06689 11.8242H9.59374C11.2831 11.8242 12.806 12.8422 13.452 14.4032L14.9479 18.0183C15.7082 19.8555 18.2666 19.9717 19.1903 18.2109V18.2109C19.5952 17.4391 20.3948 16.9556 21.2664 16.9556H24.4976C26.6392 16.9556 28.6736 16.0181 30.065 14.3899L30.5234 13.8535C31.6238 12.5657 33.2328 11.8242 34.9267 11.8242H36.3107C38.379 11.8242 40.1368 13.3359 40.4464 15.3809V15.3809C40.9317 18.5872 44.7231 20.0456 47.232 17.9911L50.9905 14.9135C52.2321 13.8968 53.7874 13.3413 55.3922 13.3413H67.2061C67.7381 13.3413 68.2678 13.2713 68.7816 13.1331L70.0447 12.7934C72.1337 12.2316 74.3263 13.2385 75.2615 15.189V15.189C76.5394 17.8545 79.9992 18.5801 82.2403 16.6527L84.2553 14.9198C85.4396 13.9013 86.9498 13.3413 88.5118 13.3413H90.6531",
    stroke: "#6F6CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76611 32.1634L10.1118 28.9454C11.3727 27.2155 14.0413 27.534 14.8598 29.512V29.512C15.8045 31.7949 19.0499 31.7611 19.9468 29.4589L20.5651 27.8718C21.4647 25.5627 24.534 25.1074 26.0652 27.0559L26.3891 27.468C27.4699 28.8435 29.5391 28.886 30.6755 27.5561V27.5561C31.8091 26.2296 33.8716 26.2679 34.9551 27.6355L37.843 31.2805C38.7052 32.3686 40.0173 33.0031 41.4056 33.0031H42.7764C43.1042 33.0031 43.4185 33.1333 43.6502 33.365V33.365C44.3125 34.0273 45.4421 33.7408 45.7087 32.843L47.0099 28.4608C47.5086 26.7815 49.0519 25.6298 50.8037 25.6298H59.1596C60.4854 25.6298 61.719 26.3079 62.4296 27.4272L62.8789 28.135C64.1142 30.081 66.9149 30.1893 68.2968 28.3444V28.3444C69.4101 26.8581 71.5312 26.5853 72.9844 27.7415L76.7347 30.7252C77.9051 31.6564 79.3566 32.1634 80.8523 32.1634H82.9907C84.1794 32.1634 85.2665 31.4932 85.8005 30.4312V30.4312C86.3345 29.3692 87.4217 28.699 88.6104 28.699H90.9849",
    stroke: "#6FD7A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.69043,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9561,
    y: 44.6553,
    width: 3.26565,
    height: 7.30333,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2217,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4873,
    y: 40.2666,
    width: 3.26565,
    height: 11.6921,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7529,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0186,
    y: 46.5173,
    width: 3.26565,
    height: 5.44144,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4653,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.731,
    y: 44.6553,
    width: 3.26565,
    height: 7.30333,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9966,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 55.2622,
    y: 40.2666,
    width: 3.26565,
    height: 11.6921,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5278,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7935,
    y: 46.5173,
    width: 3.26565,
    height: 5.44144,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6504,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 76.916,
    y: 44.6553,
    width: 3.26565,
    height: 7.30333,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 82.1816,
    y: 35.8181,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 87.4473,
    y: 40.2666,
    width: 3.26565,
    height: 11.6921,
    rx: 1.63283,
    fill: "#E0EBF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendsIconHorizontal);
export default __webpack_public_path__ + "static/media/trends_icon_horizontal.60746d4a11eba779f35ff0d8f273b561.svg";
export { ForwardRef as ReactComponent };